import { Link } from 'react-router-dom';
import { IoIosSearch } from "react-icons/io";

const CallToAction = () => {
  return (
    <section id='cta' className='bg-brightRed'>
      <div className='container flex flex-col items-center justify-between px-6 py-24 mx-auto space-y-12 md:py-12 md:flex-row md:space-y-0'>
        <div>
          <h2 className='text-5xl font-bold leading-tight text-center text-white md:text-4xl md:max-w-xl md:text-left'>
            Transforme a Reforma Tributária em uma oportunidade
          </h2>
          <p className='mt-5 text-white max-w-2xl'>
            O AuditPro é mais que uma ferramenta — é um parceiro estratégico na jornada de adaptação fiscal da sua empresa.
            Simplifique sua rotina tributária, assegure conformidade e garanta que a Reforma Tributária impulsione, e não atrase, seus resultados.
          </p>
        </div>
        <div>
          <Link
            to='/classificacao-tributaria'
            className='hidden p-3 md:flex flex-row! items-center gap-2 px-6 pt-2 text-brightRed bg-white rounded-full baseline hover:bg-brightRedLight'
          >
            <IoIosSearch />
            <p>Consultar classificação tributária</p>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
